import { useContext, useEffect, useMemo, useState } from "react"
import LocalAnimations from "@/assets/AppAssets/animation/AnimationConfig.json"
import './index.scss'
import { FilterContext } from "@/App"
import { RENDER_SDK, RESOURCE_MANAGER } from "@/config"
import ImgCaptureBtn from "./components/ImgCaptureBtn"
import { Col, Row } from "antd"
import { AvatarContext } from "@/components/RenderComp/Avatar"

const AvatarRender = () => {
    const { avatarConfig, avatar } = useContext(AvatarContext) as FilterContext<typeof AvatarContext>
    const [selectedAnimationPath, setSelectedAnimationPath] = useState('')

    const gender = useMemo(() => {
        return avatarConfig?.data.gender as string || 'female'
    }, [avatarConfig])

    async function selectAnimation(animation) {
        setSelectedAnimationPath(animation.path)
        const caseGender = gender.slice(0, 1).toUpperCase() + gender.slice(1).toLowerCase()
        await RENDER_SDK._resourceManager?.prepareCustomBundle(
            animation.path,
            animation.path
        )
        avatar.setAnimation(animation.path, 'DefaultAnimNode', true)
        const animationInterval = setInterval(() => {
            if (avatar.getAnimationProgress() > 1) {
                avatar.setAnimation(
                    `GAssets/animation/Asia${caseGender}/common/ani_ptag_a${gender}_huxi.bundle`,
                    'DefaultAnimNode',
                    true
                )
                clearInterval(animationInterval)
            }
        }, 50)
    }
    useEffect(() => {
        // RESOURCE_MANAGER.getAnimationList()
        return () => {
            const caseGender = gender.slice(0, 1).toUpperCase() + gender.slice(1).toLowerCase()
            if (avatar) {
                avatar.setAnimation(
                    `GAssets/animation/Asia${caseGender}/common/ani_ptag_a${gender}_huxi.bundle`,
                    'DefaultAnimNode',
                    true
                )
            }
        }
    }, [])

    return (
        <div className="animation-content">
            <ImgCaptureBtn className="capture-btn" />
            <p className="title">动作列表</p>
            <div
                className="animation-list"
            >
                {
                    LocalAnimations[gender]?.map(animation => (
                        <Col
                            span={
                                document.documentElement.clientWidth > 640 ? 8 : 6
                            }
                            key={animation.path}
                            className={
                                selectedAnimationPath === animation.path
                                    ? 'animation-item active'
                                    : 'animation-item '
                            }
                            onClick={() => selectAnimation(animation)}
                        >
                            <img className="bundle-icon" src={require('@/assets/' + animation.icon_url)} alt="" />
                            {animation.name}
                        </Col>
                    ))
                }
            </div>
        </div>
    )
}

export default AvatarRender
